import { c as _c } from "react/compiler-runtime";
import { ListStatusIcon } from "@components/common/faro-table/bulk-dialog/content-list/list-status-icon";
import { MemberListContent } from "@components/common/faro-table/bulk-dialog/content-list/member-list-content";
import { ProjectListContent } from "@components/common/faro-table/bulk-dialog/content-list/project-list-content";
import { TeamListContent } from "@components/common/faro-table/bulk-dialog/content-list/team-list-content";
import { SnapshotListContent } from "@components/common/faro-table/bulk-dialog/content-list/snapshot-list-content";
import { ListItem, NO_TRANSLATE_CLASS, red } from "@flat-ui";
import { withEllipsisTwoLines } from "@styles/common-styles";
/** List item in bulk action dialog  */
export function BulkActionListItem(t0) {
  const $ = _c(18);
  const {
    tableDataType,
    item,
    fallbackLabel
  } = t0;
  let content = null;
  bb0: switch (tableDataType) {
    case "projects":
      {
        let t1;
        if ($[0] !== item) {
          t1 = ProjectListContent({
            item
          });
          $[0] = item;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        content = t1;
        break bb0;
      }
    case "members":
      {
        let t1;
        if ($[2] !== fallbackLabel || $[3] !== item) {
          t1 = MemberListContent({
            item,
            fallbackLabel
          });
          $[2] = fallbackLabel;
          $[3] = item;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        content = t1;
        break bb0;
      }
    case "teams":
      {
        let t1;
        if ($[5] !== item) {
          t1 = TeamListContent({
            item
          });
          $[5] = item;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        content = t1;
        break bb0;
      }
    case "snapshots":
      {
        let t1;
        if ($[7] !== item) {
          t1 = SnapshotListContent({
            item
          });
          $[7] = item;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        content = t1;
        break bb0;
      }
    default:
  }
  if (!content) {
    return null;
  }
  const t1 = item.status === "not-allowed" ? red[100] : "none";
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      ml: "12px",
      ...withEllipsisTwoLines,
      maxWidth: "350px"
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1) {
    t3 = {
      px: "0px",
      fontSize: "14px",
      backgroundColor: t1,
      "& .MuiListItemText-root": t2
    };
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== item) {
    t4 = <ListStatusIcon item={item} />;
    $[12] = item;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== content || $[15] !== t3 || $[16] !== t4) {
    t5 = <ListItem sx={t3} className={NO_TRANSLATE_CLASS} secondaryAction={t4}>{content}</ListItem>;
    $[14] = content;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}